import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-fiscal-year-navigator',
  standalone: true,
  imports: [MatButtonModule, MatIconModule],
  templateUrl: './fiscal-year-navigator.component.html',
  styleUrls: ['./fiscal-year-navigator.component.less'],
})
export class FiscalYearNavigatorComponent {
  @Input() year: number = new Date().getFullYear();
  @Input() min?: number;
  @Input() max?: number;
  @Input() disabled = false;

  @Output() readonly yearChange = new EventEmitter<number>();

  static formatFy(year: number): string {
    const a = String((year - 1) % 100).padStart(2, '0');
    const b = String(year % 100).padStart(2, '0');
    return `${a}/${b}`;
  }

  get label(): string {
    return FiscalYearNavigatorComponent.formatFy(this.year);
  }

  get canGoBack(): boolean {
    return !this.disabled && (this.min == null || this.year > this.min);
  }

  get canGoForward(): boolean {
    return !this.disabled && (this.max == null || this.year < this.max);
  }

  prev(): void {
    if (this.canGoBack) {
      this.yearChange.emit(this.year - 1);
    }
  }

  next(): void {
    if (this.canGoForward) {
      this.yearChange.emit(this.year + 1);
    }
  }
}
